module.exports = __webpack_public_path__ + "2020celebration/img/family-r-1.0bc21da8.png";